import { useDispatch } from "react-redux";
import { GlobalFetchPartition } from "./reducer";
import { useStatusForGlobalFetchPartition } from "./useSelectors";
import thunkCollection from "./thunkCreators/collection";
import { FetchStatus } from "../../globalConsts";

// eslint-disable-next-line import/prefer-default-export
export const useGlobalFetch = (partition: GlobalFetchPartition) => {
  const dispatch = useDispatch();
  const status = useStatusForGlobalFetchPartition(partition);

  const fetchThunk = thunkCollection[partition];

  if (status === FetchStatus.Uninitialized) {
    dispatch(fetchThunk());
  }

  if (status === FetchStatus.Failed) {
    throw new Error(`Failed global fetch for partition: ${partition}`);
  }
};
